export default {
    "Features.index.589609-0": "Explore functions",
    "Features.index.589609-1": "You can use this section to list the features of your product.",
    "Features.index.589609-2": "More than 20 use case based application pages",
    "Features.index.589609-3": "Over 100 components and small parts",
    "Features.index.589609-4": "Practical Chart Library",
    "Features.index.589609-5": "Compliant with HTML5+CSS3 standards",
    "Features.index.589609-6": "Built on Bootstrap 5 and SCSS",
    "Features.index.589609-7": "Fully responsive",
    "Features.index.589609-8": "Beautiful interface",
    "Features.index.589609-9": "Free updates and support"
}